module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "done-tasks-feed"
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("ÚLTIMAS TAREFAS REALIZADAS")]), _c('br'), _c('div', {
    staticClass: "filters"
  }, [(_vm.show_user_filter) ? _c('dropdown-select', {
    staticClass: "field",
    attrs: {
      "options": _vm.users_options
    },
    on: {
      "input": _vm.reloadTasks
    },
    model: {
      value: (_vm.user_filter),
      callback: function($$v) {
        _vm.user_filter = $$v
      },
      expression: "user_filter"
    }
  }) : _vm._e()], 1), _c('br'), _c('div', {
    staticClass: "done-tasks-wrapper"
  }, [_c('list', {
    ref: "done_tasks_list",
    attrs: {
      "filters": _vm.done_today_filters
    },
    on: {
      "toggle-task-bar": _vm.bubbleUp
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a68a2ac!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/done_tasks/done_tasks_feed.vue
// module id = 1011
// module chunks = 1